import { Fragment } from 'react'
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import ApplyTagsComponent from './ApplyTags'

const ApplyTagsPage = () => {
    return (
        <Fragment>
            <Container fluid={true} style={{ paddingTop: '30px' }}>
                <Row>
                    <Col sm='12'>
                        <Card>
                            <CardBody style={{ padding: '20px' }}>
                                <ApplyTagsComponent />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default ApplyTagsPage;
